import React from "react";
import { connect } from "react-redux";
import AccessGroupTable from "./components/AccessGroupTable";

const AccessGroups = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<AccessGroupTable/>

	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessGroups);